import React from 'react'
import ImageGallery from 'react-image-gallery'
import styled from 'styled-components'
import 'react-image-gallery/styles/css/image-gallery.css'
import './ImageSlider.scss'

export default function ImageSlider(props) {
  const {
    slice
  } = props
  function test(item) {
    if (item.mynd_type === 'Cover') {
      return (
        <img
          src={item.original}
          className='imageSlider__cover'
          alt={item.originalAlt}
        />
      )
    } else if (item.mynd_type === 'Contain') {
      return (
        <img
          src={item.original}
          className='imageSlider__contain'
          alt={item.originalAlt}
        />
      )
    }

  }

  let myItems = []
  slice.items.map(item => myItems.push({ 
    mynd_type: item.mynd_type, 
    original: item.mynd.url, 
    thumbnail: item.thumbnail.url, 
    originalAlt: item.mynd.alt,
    thumbnailAlt: item.mynd.alt,
    renderItem: test,
    
  }))

  const GalleryContainer = styled.div`
  .image-gallery {
     height: 550px;
   }
  .image-gallery-slide {
     object-fit: contain;
  }
`


  return (
    <div style={{ width: '90%', margin: '40px auto 40px' }}>
      <ImageGallery items={myItems} showFullscreenButton={false} showPlayButton={false} />

    </div>
  )
}